export enum SkeletonRadius {
    MAX = "max",
    LARGE = "large",
    MEDIUM = "medium",
    SMALL = "small",
}

export enum SkeletonColor {
    GREY = "grey",
    GLASS = "glass",
    LIGHTGREY = "lightgrey",
    TRANSPARENT = "transparent",
}

export type SkeletonProps = {
    radius: SkeletonRadius;
    color: SkeletonColor;
    width?: CSSStyleDeclaration["width"];
    height?: CSSStyleDeclaration["height"];
} & React.ButtonHTMLAttributes<HTMLDivElement>;

export type DefaultSkeletonProps = {
    width: NonNullable<SkeletonProps["width"]>;
    height: NonNullable<SkeletonProps["height"]>;
};
